import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface EyebrowProps {
  children: ReactNode;
  className?: string;
  /** "light" = bg verde claro + texto verde escuro (default, para seções claras).
   *  "dark" = bg verde escuro + texto verde claro (para seções escuras). */
  variant?: "light" | "dark";
}

/**
 * Pill / badge usado como section eyebrow.
 * Estilo alinhado ao allugatorinvest.com.
 */
export const Eyebrow = ({
  children,
  className,
  variant = "light",
}: EyebrowProps) => {
  const variantClass =
    variant === "dark"
      ? "bg-[#1F4A33] text-[#D1F8E2]"
      : "bg-[#D1F8E2] text-[#112711]";

  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full px-4 py-1.5 text-[11px] sm:text-xs font-bold tracking-[0.12em] uppercase",
        variantClass,
        className
      )}
    >
      {children}
    </span>
  );
};
